<p>{{ 'TERMSOFUSE.MAINTEXT' | translate }} </p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H1.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H1.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H2.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H2.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H3.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H3.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H4.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H4.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H5.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H5.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H6.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H6.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H7.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H7.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H8.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H8.TEXT1' | translate }}:</p>
<ul>
  <li>{{ 'TERMSOFUSE.H8.LI1' | translate }}</li>
  <li>{{ 'TERMSOFUSE.H8.LI2' | translate }}</li>
  <li>{{ 'TERMSOFUSE.H8.LI3' | translate }}</li>
  <li>{{ 'TERMSOFUSE.H8.LI4' | translate }}</li>
  <li>{{ 'TERMSOFUSE.H8.LI5' | translate }}</li>
  <li>{{ 'TERMSOFUSE.H8.LI6' | translate }}</li>
</ul>
<p>{{ 'TERMSOFUSE.H8.TEXT2' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H9.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H9.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H10.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H10.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H11.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H11.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H12.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H12.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H13.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H13.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H14.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H14.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H15.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H15.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H16.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H16.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H17.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H17.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H18.TITLE' | translate }}</h4>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H19.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H19.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H20.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H20.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H21.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H21.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H22.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H22.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H23.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H23.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H24.TITLE' | translate }}</h4>
<p>{{ 'TERMSOFUSE.H24.TEXT' | translate }}</p>
<h4 class="h4 blue">{{ 'TERMSOFUSE.H25.TITLE' | translate }}</h4>
<ul>
  <li>{{ 'TERMSOFUSE.H25.LI1' | translate }}</li>
  <li>{{ 'TERMSOFUSE.H25.LI2' | translate }}</li>
  <li>{{ 'TERMSOFUSE.H25.LI3' | translate }}</li>
  <li>{{ 'TERMSOFUSE.H25.LI4' | translate }}</li>
  <li>{{ 'TERMSOFUSE.H25.LI5' | translate }}</li>
  <li>{{ 'TERMSOFUSE.H25.LI6' | translate }}</li>
  <li>{{ 'TERMSOFUSE.H25.LI7' | translate }}</li>
  <li>{{ 'TERMSOFUSE.H25.LI8' | translate }}</li>
</ul>
